/**
 * Rewrites the description HTML before submission: checked inline images become
 * `[image: filename]` markers (cid: links are permanently broken in SolarWinds), and
 * unchecked inline images have their tags removed entirely.
 */

export function rewriteInlineImages(
  html: string,
  decisions: { contentId?: string; name: string; include: boolean }[],
): string {
  if (typeof DOMParser === 'undefined') return html;

  const doc = new DOMParser().parseFromString(`<div id="root">${html}</div>`, 'text/html');
  const root = doc.getElementById('root');
  if (!root) return html;

  const byCid = new Map<string, { name: string; include: boolean }>();
  for (const d of decisions) {
    if (!d.contentId) continue;
    const key = d.contentId.replace(/^<|>$/g, '').toLowerCase();
    byCid.set(key, { name: d.name, include: d.include });
  }

  const images = [...root.querySelectorAll('img')];
  for (const img of images) {
    // Shipped Outlook builds have emitted originalsrc with no src.
    const raw = img.getAttribute('src') || img.getAttribute('originalsrc') || '';
    const cidMatch = /^cid:(.+)$/i.exec(raw.trim());
    if (!cidMatch?.[1]) continue;

    const key = cidMatch[1].replace(/^<|>$/g, '').toLowerCase();
    const decision = byCid.get(key);

    if (!decision || !decision.include) {
      img.remove();
      continue;
    }

    const marker = doc.createTextNode(`[image: ${decision.name}]`);
    img.replaceWith(marker);
  }

  return root.innerHTML;
}
